import { ReadingTimeStats } from '@models/shared/readingTimeStats.type.interface';
import { IStatusType } from '@models/shared/status.type.interface';

export class HowTo {
  _id?: string;
  id?: number;
  asCat?: number;
  title?: string;
  title_tag?: string; // SEO Meta
  meta_description?: string; // SEO Meta
  category?: string;
  categoryTitle?: string;
  imgUrl?: string;
  author?: string;
  status?: IStatusType;
  slug?: string;
  newSlug?: string;
  guide?: boolean;
  date?: string;
  publish_date?: string;
  content?: any | null;
  main_category_title?: string;
  main_category_slug?: string;
  how_to_schema?: any;
  sub_header?: string;
  mainCategory?: { slug: string };
  subCategory?: { slug: string };
  // Stats
  readingTimeStats?: ReadingTimeStats;
  viewCount: number = 0;
  imgAltAttribute?: string;
  shortExplanation?: string;
  question?: string;
  constructor(data: any = null) {
    Object.assign(this, data);
  }
}
